import React from 'react';
import { Button, Typography, Grid, Stack } from '@mui/material';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux'
import CssTextField from '../../../overrides/longSearchField';
import CloseButton from '../../../overrides/closeButton';
import { saveCafeteriaWatcher } from '../../../../redux/actionCreators/admin/cafeteria';

function CafeteriaCreation(props) {
    const dispatch = useDispatch()

    const { setOpen } = props;

    const CafeteriaSchema = Yup.object().shape({
        cafeteria: Yup.string()
            .trim()
            .min(2, 'Too Short!')
            .max(250, 'Too Long!')
            .required('Cafeteria name is required'),
    });

    const formik = useFormik({
        initialValues: {
            cafeteria: '',
        },

        validationSchema: CafeteriaSchema,

        onSubmit: () => {
            dispatch(saveCafeteriaWatcher({
                ACTION: 'INSERT',
                CAFETERIA: formik.values.cafeteria.trim()
            }, setOpen))
        }
    });

    const { errors, touched, handleSubmit, getFieldProps } = formik;

    return (
        <>
            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <Typography variant='h5' align='left' style={{ paddingBottom: '10px' }}>
                        Cafeteria Creation
                    </Typography>

                    <Grid container style={{ paddingTop: '10px' }} spacing={3} direction='row'>
                        <Grid lg={6} md={6} sm={6} xs={12} item={true}>
                            <CssTextField
                                required={true}
                                fullWidth={true}
                                placeholder='Cafeteria Name'
                                label='Cafeteria Name'
                                name='cafeteria'
                                color='primary'
                                type='text'
                                variant='outlined'
                                {...getFieldProps("cafeteria")}
                                error={Boolean(touched.cafeteria && errors.cafeteria)}
                                helperText={touched.cafeteria && errors.cafeteria}
                            />
                        </Grid>

                        <Grid xs={12} item={true}>
                            <Stack spacing={2} direction='row' justifyContent='end' >
                                <CloseButton onClick={() => setOpen(false)}
                                    sx={{
                                        height: '42px',
                                        left: '0px',
                                        top: '0px',
                                        minWidth: '120px',
                                        marginTop: 'auto',
                                    }}
                                    variant='contained'
                                    size='medium'
                                    type='button'>
                                    <Typography variant='t14_400' color='common.black'>Cancel</Typography>
                                </CloseButton>
                                <Button onClick={handleSubmit}
                                    style={{
                                        height: '42px',
                                        left: '0px',
                                        top: '0px',
                                        minWidth: '120px',
                                        backgroundColor: 'common.Bblack',
                                        marginTop: 'auto'
                                    }}
                                    variant='contained'
                                    size='medium'
                                    type='submit'
                                >
                                    <Typography variant='t14_400' color='grey.0'>Submit</Typography>
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </Form>
            </FormikProvider>
        </>
    );
}

export default CafeteriaCreation;
